import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalculationForm = _resolveComponent("CalculationForm")!
  const _component_CalculationPageWrapper = _resolveComponent("CalculationPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_CalculationPageWrapper, {
        key: 0,
        title: "Пересчет газа",
        type: _ctx.getType
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CalculationForm, {
            buttonText: "Пересчитать данные по газу",
            buttonLoadingText: "Пересчет...",
            disabled: _ctx.getUploadingDataStatus.isProgress,
            isLoading: _ctx.getIsFormLoading,
            onSubmit: _ctx.handleSubmitForm
          }, null, 8, ["disabled", "isLoading", "onSubmit"])
        ]),
        _: 1
      }, 8, ["type"]))
    : _createCommentVNode("", true)
}